import { get } from 'lodash'
import { required, requiredPhone, email, phone } from 'utils/validation'

const validate = values => {
  let errors = {}

  const awardLeaderRegistration = {
    email: required(get(values, 'awardLeaderRegistration.email')) ||
      email(get(values, 'awardLeaderRegistration.email')),
    phoneNumber: requiredPhone(
      get(values, 'awardLeaderRegistration.phoneNumber')
    ) || phone(get(values, 'awardLeaderRegistration.phoneNumber')),
    phoneType: {
      value: required(get(values, 'awardLeaderRegistration.phoneType.value'))
    },
    emailAgain: required(get(values, 'awardLeaderRegistration.emailAgain'))
  }

  errors = {
    awardLeaderRegistration
  }

  if (
    get(values, 'awardLeaderRegistration.email') &&
    get(values, 'awardLeaderRegistration.emailAgain')
  ) {
    if (
      get(values, 'awardLeaderRegistration.email') !==
      get(values, 'awardLeaderRegistration.emailAgain')
    ) {
      errors = {
        ...errors,
        awardLeaderRegistration: {
          ...errors.awardLeaderRegistration,
          emailAgain: {
            text: "Emails don't match",
            intlKey: 'errors.emails_dont_match'
          }
        }
      }
    }
  }

  if (get(values, 'awardLeaderRegistration.email') && get(values, 'email')) {
    if (get(values, 'awardLeaderRegistration.email') === get(values, 'email')) {
      errors = {
        ...errors,
        awardLeaderRegistration: {
          ...errors.awardLeaderRegistration,
          email: {
            text: 'This email is already in use by Authorising Contact',
            intlKey: 'errors.already_in_use_by_auth_contact'
          }
        }
      }
    }
  }

  return errors
}

export default validate
